import { render, staticRenderFns } from "./TableOrder.vue?vue&type=template&id=8b3229b4&scoped=true&"
import script from "./TableOrder.vue?vue&type=script&lang=js&"
export * from "./TableOrder.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=8b3229b4&lang=less&scoped=true&"
import style1 from "../../less/tableOrder.less?vue&type=style&index=1&id=8b3229b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3229b4",
  null
  
)

export default component.exports